module.exports = __webpack_public_path__ + "img/SKMJ_check7.fcf05b89.png";